import React from 'react';
import { withRouter } from 'react-router-dom';

export default withRouter(class Header extends React.Component {
    goBack = () => {
        if(this.props.timestamp && this.props.chair)
            this.props.history.push(`/home/pick-day/${this.props.timestamp}/${this.props.chair}`);
        else
            this.props.history.goBack();
    }

    render() {
        return (
            <div className="navbar">
                <div className="navbar-brand">
                    <div className="navbar-item">
                        <a onClick={this.goBack}><i className="fas fa-arrow-left"></i> Atrás</a>
                    </div>
                </div>
            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/appointment-details/components/header/index.js